import { render } from "./ButtonMenu.vue?vue&type=template&id=2e57c172"
import script from "./ButtonMenu.vue?vue&type=script&lang=js"
export * from "./ButtonMenu.vue?vue&type=script&lang=js"
script.render = render

export default script